import './LatestVideos.css';

import React, { useEffect, useState } from 'react';

import db from '../../Core/firebaseCore';
import Card from './Card';

function LatestVideos() {
    const [videos, setLatestVideos] = useState([]);
    useEffect(async () => {
        const _snapshot = await db.collection('videos').where('active', '==', true).orderBy('createdOn', 'desc').limit(5).get();
        let videos_local = _snapshot.docs.map((doc) => {
            let _data = doc.data();
            _data.id = doc.id;
            return _data;
        });
        setLatestVideos(videos_local);
    }, []);

    return (
        <div className="latest-videos">
            <p className="header">Latest Videos</p>
            <Card videos={videos}/>
        </div>
    )
}

export default LatestVideos
